import React, { useState } from "react";
import Navigation from "./components/Navigation";
import P2PExceptions from "./pages/p2pexceptions";
import O2CExceptions from "./pages/o2cexceptions";
import CreditMemo from "./pages/o2c-exception-handling-credit-memo";
import DemoExceptionHandling from "./pages/paymentReconciliation";
import Meter2CashExceptions from "./pages/meter-2-cash";
import OrderProcessing from "./pages/order-processing";
import CreditManagement from "./pages/credit-management";
import CashApplication from "./pages/cash-application";
import SOPViewer from "./pages/sop-viewer";
import MarkdownEditorPage from "./pages/markdown-editor";
import Login from "./pages/Login";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// Inline PrivateRoute component
function PrivateRoute({ isLoggedIn, children }) {
  const location = useLocation();

  if (!isLoggedIn) {
    // Preserve the current path and search params as callback URL
    const callbackUrl = `${location.pathname}${location.search}`;
    return (
      <Navigate
        to={`/login?callbackUrl=${encodeURIComponent(callbackUrl)}`}
        replace
      />
    );
  }

  return children;
}

function App() {
  const [userEmail, setUserEmail] = useState(() =>
    localStorage.getItem("userEmail"),
  );
  const [isLoggedIn, setIsLoggedIn] = useState(
    () => localStorage.getItem("isLoggedIn") === "true",
  );
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  const isSOPPage = location.pathname === "/sop";
  const isSOPEditorPage = location.pathname === "/sop-editor";

  return (
    <div className="min-h-screen bg-fiori-page text-fiori-text font-sans">
      {!isLoginPage && !isSOPPage && !isSOPEditorPage && (
        <Navigation
          email={userEmail}
          setEmail={setUserEmail}
          setIsLoggedIn={setIsLoggedIn}
        />
      )}
      <Routes>
        <Route
          path="/login"
          element={
            <Login setEmail={setUserEmail} setIsLoggedIn={setIsLoggedIn} />
          }
        />

        <Route
          path="/"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <Navigate to="/p2p" />
            </PrivateRoute>
          }
        />
        <Route
          path="/p2p"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <P2PExceptions />
            </PrivateRoute>
          }
        />
        <Route
          path="/o2c"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <O2CExceptions userEmail={userEmail} />
            </PrivateRoute>
          }
        />
        <Route
          path="/credit-memo"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <CreditMemo />
            </PrivateRoute>
          }
        />
        <Route
          path="/payment-reconciliation"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <DemoExceptionHandling />
            </PrivateRoute>
          }
        />

        <Route
          path="/meter-2-cash"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <Meter2CashExceptions />
            </PrivateRoute>
          }
        />

        <Route
          path="/order-processing"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <OrderProcessing />
            </PrivateRoute>
          }
        />

        <Route
          path="/credit-management"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <CreditManagement />
            </PrivateRoute>
          }
        />

        <Route
          path="/cash-application"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <CashApplication />
            </PrivateRoute>
          }
        />

        <Route
          path="/sop"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <SOPViewer />
            </PrivateRoute>
          }
        />

        <Route
          path="/sop-editor"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <MarkdownEditorPage />
            </PrivateRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
